import React from 'react';
import {
    Box,
    Typography,
    Paper,
    Button
} from '@mui/material';
import { Announcement as AnnouncementIcon, Add as AddIcon } from '@mui/icons-material';
import DataSourceCard from './DataSourceCard';

/**
 * Component for the data sources section
 */
const DataSourcesSection = ({
    dataSources,
    connectingSourceIds,
    onAddClick,
    onEditClick,
    onDeleteClick,
    onViewClick,
    onTestConnection,
    currentUserId,
    showHeader = true
}) => {
    return (
        <Paper
            elevation={0}
            sx={{
                bgcolor: 'var(--wb-bg-elevated)',
                p: 3,
                borderRadius: 2,
                mb: 4
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: showHeader ? 'space-between' : 'flex-end',
                    alignItems: 'center',
                    mb: 2
                }}
            >
                {showHeader && (
                    <Typography variant="h6" color="var(--wb-text-strong)">
                        Fuentes de Datos
                    </Typography>
                )}
                <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={onAddClick}
                    sx={{
                        bgcolor: 'var(--wb-primary)',
                        '&:hover': { bgcolor: 'var(--wb-primary-hover)' }
                    }}
                >
                    Agregar conexión
                </Button>
            </Box>

            {/* Descripción de fuentes de datos */}
            <Paper
                elevation={0}
                sx={{
                    bgcolor: 'var(--wb-bg-card)',
                    p: 2,
                    borderRadius: 2,
                    mb: 3,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2
                }}
            >
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <AnnouncementIcon sx={{ color: 'var(--wb-primary)' }} />
                </Box>
                <Typography variant="body2" color="var(--wb-text-strong)">
                    WhisperBI puede conectarse a bases de datos (MySQL, PostgreSQL, SQL Server) y archivos
                    (Excel, PDF, PowerPoint). También soporta almacenamiento en la nube y APIs REST.
                </Typography>
            </Paper>

            {/* Lista de fuentes de datos */}
            {dataSources.length === 0 ? (
                <Box sx={{ textAlign: 'center', py: 4 }}>
                    <Typography variant="body1" color="var(--wb-text-strong)">
                        No hay fuentes de datos configuradas. Haz clic en "Agregar conexión" para comenzar.
                    </Typography>
                </Box>
            ) : (
                dataSources.map((source) => (
                    <DataSourceCard
                        key={source.id}
                        source={source}
                        connectingSourceIds={connectingSourceIds}
                        currentUserId={currentUserId}
                        onTest={onTestConnection}
                        onEdit={onEditClick}
                        onDelete={onDeleteClick}
                        onView={onViewClick}
                    />
                ))
            )}
        </Paper>
    );
};

export default DataSourcesSection;
